import $ from 'jquery';
import _ from "underscore";
import { setElementsFromScope, insertValAndManageFocus, setDisabled, setEnabled } from "../../utilities/selectorHelpers";
import { isPresent } from "../../utilities/general";
import { addCustomClassForSelect2 } from "../../utilities/select2able";
import moment from "moment";
require("./timePicker.less");
const rawTemplateHtml = require('./html/timePickerTemplate.html');
// dependencies:
// select2


export default function timePicker(el, options) {
  el = $(el);

  let tmEl;

  if (el.children().length) {
    tmEl = getTimePicker();
  }
  else {
    el.html(rawTemplateHtml);
    tmEl = getTimePicker();
  }

  function getTimePicker() {
    let tm = el.data("time-picker");
    if (tm) {
      tm.setOptions(options);
    }
    else {
      tm = new TimePicker(el, options);
    }
    return tm;
  }

  return tmEl;
}

const DEFAULTS = {

}

const HOURS_DATA_DEFAULT = {
  hoursData: {
    data: [
      {
        id: "",
        text: "HH"
      }
    ]
  }
}

const MINUTES_DATA_DEFAULT = {
  minutesData: {
    data: [
      {
        id: "",
        text: "MM"
      }
    ]
  }
}

const elementsMap = {
  hoursSelect: ".time-picker-hours-select",
  minutesSelect: ".time-picker-minutes-select",
  periodSelect: ".time-picker-period-select",
  timePickerSeparater: ".time-picker-seperater"
}

function TimePicker(el, options = {}) {
  const self = this;
  let opts;
  const els = {};

  generateHours();
  generateMinutes();

  setOptions(options);
  setElements();
  handleReadOnly();
  setWidgets();
  bindElements();

  self.setOptions = setOptions;

  self.setTimeFromMilitary = function (time) {
    const [hours, minutes, period] = moment(time, 'HH:mm').format('h:mm:A').split(":");

    if (hours !== "Invalid date") {
      setVal(els.hoursSelect, hours);
      setVal(els.minutesSelect, minutes);
      setVal(els.periodSelect, period);
    }
  }

  function setVal(el, val) {
    el.val(val).trigger('change.select2');
  }

  self.getMilitaryTime = function () {
    const hours = getHoursVal();
    const minutes = getMinutesVal();
    const period = getPeriodVal();

    return moment(hours + ":" + minutes + " " + period, 'h:mm A').format('HH:mm');
  }

  self.resetTime = function () {
    setVal(els.hoursSelect, '');
    setVal(els.minutesSelect, '');
    setVal(els.periodSelect, 'AM');
  }

  self.disableTimePicker = function () {
    setDisabled([
      els.hoursSelect,
      els.minutesSelect,
      els.periodSelect
    ]);
    els.timePickerSeparater.css('background-color', '#f5f5f5');
    handleDisabledSelect2();
  }

  self.enableTimePicker = function () {
    setEnabled([
      els.hoursSelect,
      els.minutesSelect,
      els.periodSelect
    ]);
    els.timePickerSeparater.css('background-color', '');
    handleEnabledSelect2();
  }

  function getHoursVal() {
    return getVal(els.hoursSelect);
  }
  function getMinutesVal() {
    return getVal(els.minutesSelect);
  }
  function getPeriodVal() {
    return getVal(els.periodSelect);
  }

  function getVal(el) {
    return el.val();
  }

  function bindElements() {

  }

  function parsedNotNaN(val) {
    return !_.isNaN(parseDigit(val));
  }

  function parseDigit(val) {
    return parseInt(val, 10);
  }

  function setOptions(options = {}) {
    opts = _.defaults(options, DEFAULTS);
  }

  function setElements() {
    setElementsFromScope(els, elementsMap, el);
  }

  function setWidgets() {
    setSelect2s();
  }

  function setSelect2s() {
    els.periodSelect.select2({
      minimumResultsForSearch: "Infinity",
      data: [
        {
          id: "AM",
          text: "AM"
        },
        {
          id: "PM",
          text: "PM"
        }
      ]
    });
    els.hoursSelect.select2({
      minimumResultsForSearch: "Infinity",
      data: HOURS_DATA_DEFAULT.hoursData.data,
      placeholder: 'HH'
    });
    els.minutesSelect.select2({
      minimumResultsForSearch: "Infinity",
      data: MINUTES_DATA_DEFAULT.minutesData.data,
      placeholder: 'MM'
    });

    els.periodSelect.data('select2').$dropdown.addClass('time-picker-period-select-dropdown');

    if (opts.addSelect2Class) {
      addCustomClassForSelect2(els.hoursSelect, opts.addSelect2Class);
      addCustomClassForSelect2(els.minutesSelect, opts.addSelect2Class);
      addCustomClassForSelect2(els.periodSelect, opts.addSelect2Class);
    }
  }

  function generateHours() {
    if (HOURS_DATA_DEFAULT.hoursData.data.length > 1) {
      return;
    }
    const data = HOURS_DATA_DEFAULT.hoursData.data;
    fillWithData(data, 1, 12, { prefixZero: false });
  }

  function generateMinutes() {
    if (MINUTES_DATA_DEFAULT.minutesData.data.length > 1) {
      return;
    }
    const data = MINUTES_DATA_DEFAULT.minutesData.data;
    fillWithData(data, 0, 59, { prefixZero: true });
  }

  function fillWithData(data, start, finish, { prefixZero }) {
    for (var i = start; i <= finish; i++) {
      let str = "";
      if (prefixZero && i >= 0 && i < 10) {
        // "01"
        str = "0" + i;
      }
      else {
        str = "" + i;
      }
      data.push({ id: str, text: str });
    }
  }

  function handleReadOnly() {
    if (options.disableAll) {
      setDisabled([
        els.hoursSelect,
        els.minutesSelect,
        els.periodSelect
      ])
      setComponentLevelDisabled();
    }
  }

  function setComponentLevelDisabled() {
    el.addClass("disabled");
  }

  function handleDisabledSelect2(){
    [
      els.hoursSelect,
      els.minutesSelect,
      els.periodSelect
    ].map((eachSelect2)=>{
      eachSelect2.closest('.q-time-picker-default')
      .find('.select2-container') // Targeting parent class div to avoid selection is disabled mode.
      .css('pointer-events','none'); // This would take care of every timePicker whether new or old.
    });
  }

  function handleEnabledSelect2(){
    [
      els.hoursSelect,
      els.minutesSelect,
      els.periodSelect
    ].map((eachSelect2)=>{
      eachSelect2.closest('.q-time-picker-default').find('.select2-container').css('pointer-events','');
    });
  }
}


// WEBPACK FOOTER //
// ./src/components/timePicker/timePicker.js